module.exports = __webpack_public_path__ + "static/media/socket-io-svgrepo-com.d175d8b2.svg";